// extracted by mini-css-extract-plugin
export default {"wrapFirstcols":"cotizacion_wrapFirstcols__ZcukS"};